import { withTranslation } from 'react-i18next';
import {
  Document,
  Page,
  Text,
  StyleSheet,
  View,
  Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
});

const PureChart = ({ t, chart }) => {
  return (
    <View wrap={false}>
      <Text style={styles.text}>{t(chart.field).toUpperCase()}</Text>
      <Image style={styles.image} src={chart.image} />
    </View>
  );
};
const Chart = withTranslation()(PureChart);

const PureRaportLayout = ({ t, deviceData, rebootTime, dateNow, range, charts }) => {
  const name = deviceData?.name;
  const type = deviceData?.type;
  const start = range?.start;
  const end = range?.end;

  if (charts.length === 0) {
    return false;
  }

  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.header} fixed>
          Main-IoT
        </Text>
        <Text style={styles.title}>{t("data-report")} {dateNow}</Text>

        <Text style={styles.text}>
          {t("device-name")}: {name}{'\n'}
          {t("device-type")}: {t(type)}{'\n'}
          {'\n'}
          {t("time-range")}{'\n'}
          {t("time-range-start")}: {start}{'\n'}
          {t("time-range-end")}: {end}{'\n'}
          {t("latest-reboot")}: {rebootTime}{'\n'}
        </Text>

        {charts.map((chart, index) => (
          <Chart key={index} chart={chart} />
        ))}
      </Page>
    </Document>
  );
};

const RaportLayout = withTranslation()(PureRaportLayout);
export { RaportLayout };